<form [formGroup]="smsCampaignDetailsForm">
  <div class="layout-row-wrap gap-2percent responsive-column align-start-center">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Campaign Name' | translate }}</mat-label>
      <input matInput formControlName="campaignName" required />
      <mat-error>
        {{ 'labels.inputs.Campaign Name' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    @if (!smsCampaignDetailsForm.controls.isNotification.value) {
      <mat-form-field class="flex-48">
        <mat-label>{{ 'labels.inputs.SMS Provider' | translate }}</mat-label>
        <mat-select formControlName="providerId">
          @for (provider of smsProviders; track provider) {
            <mat-option [value]="provider.id">
              {{ provider.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Trigger Type' | translate }}</mat-label>
      <mat-select formControlName="triggerType" required>
        @for (triggerType of triggerTypes; track triggerType) {
          <mat-option [value]="triggerType.id">
            {{ triggerType.value }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Trigger Type' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-checkbox labelPosition="before" formControlName="isNotification" class="flex-48">
      {{ 'labels.inputs.Is Notification' | translate }}?
    </mat-checkbox>

    @if (smsCampaignDetailsForm.controls.recurrenceStartDate) {
      <mat-form-field class="flex-48" (click)="recurrenceStartDatePicker.open()">
        <mat-label>{{ 'labels.inputs.Schedule Date' | translate }}</mat-label>
        <input
          matInput
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="recurrenceStartDatePicker"
          formControlName="recurrenceStartDate"
          required
        />
        <mat-datepicker-toggle matSuffix [for]="recurrenceStartDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #recurrenceStartDatePicker></mat-datepicker>
        <mat-error>
          {{ 'labels.inputs.Schedule Date' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      </mat-form-field>
    }

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Business Rule' | translate }}</mat-label>
      <mat-select formControlName="runReportId" required>
        @for (rule of businessRules; track rule) {
          <mat-option [value]="rule.reportId">
            {{ rule.reportName }}
          </mat-option>
        }
      </mat-select>
      <mat-error>
        {{ 'labels.inputs.Business Rule' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <LOSx-edit-business-rule-parameters
    [paramData]="paramData"
    [smsCampaign]="smsCampaign"
    (templateParameters)="passParameters($event)"
  >
  </LOSx-edit-business-rule-parameters>
</form>
